
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import { CaseDetails, CaseUser, CaseField } from "@/types"

import api from "@/services/api"
const caseStore = namespace("cases")

	@Component({
		components: {
			"scrollbar": VuePerfectScrollbar,
			"v-select": vSelect
		}
	})
export default class Invite extends Vue {
	@Prop()
	public currentCase: any;

	private inviteSearch: string = "";

	private inviteUsers: any[] = [];
	private selectedItem: any = null;

	@Watch("inviteSearch")
	public async userSearch () {
		if (this.inviteSearch === "") {
			this.inviteUsers = []
		} else {
			this.inviteUsers = await api.searchInvite(this.currentCase.id, this.inviteSearch)
		}
	}

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (search === "") {
			this.inviteUsers = []
		} else {
			loading(true)
			this.inviteUsers = await api.searchInvite(this.currentCase.id, search)
			loading(false)
		}
	}

	public userPicture (inviteSearchResult: any): string {
		if (inviteSearchResult.isTeam) {
			return ""
		} else if (inviteSearchResult.imageUrl) {
			return inviteSearchResult.imageUrl!
		} else {
			return api.pictureUrl(inviteSearchResult.id)
		}
	}

	public async addUser (inviteSearchResult: any) {
		if (inviteSearchResult) {
			this.inviteSearch = ""
			if (inviteSearchResult.isTeam) {
				await api.addTeam(this.currentCase.id, inviteSearchResult.id)
			} else {
				await api.addUser(this.currentCase.id, inviteSearchResult.id)
			}
		}
		this.selectedItem = null
	}

	public loadedImage (result: any) {
		// do nothing here - this is just a handler to tell the browser not to show it until it's loaded
	}
}
